import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { uniqueId } from '@/utils/misc';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerSourcesSelect',
  props: {
    hasDatahub: { type: Boolean, default: false },
    hasSmbs: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["datahubChange", "smbsChange"],
  setup(__props: any, { emit }: { emit: ((e: 'datahubChange' | 'smbsChange', hasValue: boolean) => void), expose: any, slots: any, attrs: any }) {





const { t } = useI18n();

const componentId = uniqueId();

return { __sfc: true,emit, t, componentId }
}

})